import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import { Link } from 'react-router-dom';
import {
  Button,
  Input,
  Menu,
  Segment,
  Dropdown,
  Checkbox,
  Grid
} from 'semantic-ui-react';
import AffiliateDropdown from './dropdowns/AffiliateDropdown';
import AirlineDropdown from './dropdowns/AirlineDropdown';
import FlightNumberDropdown from './dropdowns/FlightNumberDropdown';
import SelectedFiltersLabels from './SelectedFiltersLabels';
import PassengerEmailDropdown from './dropdowns/PassengerEmailDropdown';

const booleanOptions = [
  { key: 0, value: 'true', text: 'true' },
  { key: 1, value: 'false', text: 'false' }
];

const TicketsFilters = props => {
  const {
    filters,
    onBooleanFilterChange,
    onDateFilterChange,
    onFilterAdd,
    onApply
  } = props;
  return (
    <Segment basic>
      <Menu.Item>
        <div className="ui two buttons">
          <Button basic as={Link} to="/ticket/new" primary>
            New ticket
          </Button>
        </div>
      </Menu.Item>
      <Menu.Item>
        <Menu.Header>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column verticalAlign="middle">Filter</Grid.Column>
              <Grid.Column textAlign="right">
                <Button basic size="mini" color="red" onClick={props.onClear}>
                  Clear Filters
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Menu.Header>
        <Menu.Menu>
          <Menu.Item>Sort tickets by creation date</Menu.Item>
          <Menu.Item>
            <Checkbox
              toggle
              checked={props.orderBy === 'desc'}
              label={props.orderBy === 'desc' ? 'descending' : 'ascending'}
              onChange={props.onOrderChange}
            />
          </Menu.Item>
          <Menu.Item>Claim matched</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="claim" {...props} />
            <Dropdown
              fluid
              selection
              onChange={onBooleanFilterChange.bind(this, 'claim')}
              options={booleanOptions}
              value={null}
            />
          </Menu.Item>
          <Menu.Item>Ticket form</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="ticketForm" {...props} />
            <Dropdown
              fluid
              selection
              onChange={onBooleanFilterChange.bind(this, 'ticketForm')}
              options={booleanOptions}
              value={null}
            />
          </Menu.Item>
          <Menu.Item>Ineligible</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="unclaimable" {...props} />
            <Dropdown
              fluid
              selection
              onChange={onBooleanFilterChange.bind(this, 'unclaimable')}
              options={booleanOptions}
              value={null}
            />
          </Menu.Item>
          <Menu.Item>Departure date</Menu.Item>
          <Menu.Item className="c-DatePicker__wrapper c-DatePicker__wrapper--filters">
            <DatePicker
              selected={
                filters.departureDate && moment(filters.departureDate)
              }
              dateFormat="DD/MM/YYYY"
              onChange={onDateFilterChange}
              isClearable={true}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              customInput={<Input style={{ width: '100%' }} />}
            />
          </Menu.Item>
          <Menu.Item>Airline</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="airlineNames" {...props} />
            <AirlineDropdown
              onChange={onFilterAdd.bind(this, 'airlineNames')}
              optionsValue="name"
              value={null}
            />
          </Menu.Item>
          <Menu.Item>Flight number</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="flightNumbers" {...props} />
            <FlightNumberDropdown
              value={null}
              onChange={onFilterAdd.bind(this, 'flightNumbers')}
            />
          </Menu.Item>
          <Menu.Item>Affiliate</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="affiliateNames" {...props} />
            <AffiliateDropdown
              value={null}
              onChange={onFilterAdd.bind(this, 'affiliateNames')}
            />
          </Menu.Item>
          <Menu.Item>PAX email address</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="passengerEmails" {...props} />
            <PassengerEmailDropdown
              upward
              value={null}
              onChange={onFilterAdd.bind(this, 'passengerEmails')}
            />
          </Menu.Item>
          <Menu.Item>PAX Full Name</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="firstAndLastName" {...props} />
            <Input
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  onFilterAdd.call(this, 'firstAndLastName', e, {
                    value: e.target.value
                  });
                }
              }}
            />
          </Menu.Item>
          <Menu.Item style={{ textAlign: 'center' }}>
            <Button primary onClick={onApply}>
              Apply
            </Button>
          </Menu.Item>
        </Menu.Menu>
      </Menu.Item>
    </Segment>
  );
};

export default TicketsFilters;



// WEBPACK FOOTER //
// ./src/component/TicketFilters.js